module.exports = __webpack_public_path__ + "img/xqzq.1cd2fcf.png";